import { groupBy, pathOr, prop } from 'ramda';

export const getAvailableGames = ({
  games = [],
  categories = [],
  providers = [],
}) => {
  const categoriesMap = groupBy(prop('id'))(categories);
  const providersMap = groupBy(prop('id'))(providers);

  return games.filter((game) => {
    const categories = pathOr([], ['category'], game);
    const provider = pathOr('', ['provider'], game);

    return (
      categories.some((categoryId) => !!categoriesMap[categoryId]) &&
      !!providersMap[provider]
    );
  });
};
